<template>
  <transition name="confirm-dialog-fade">
    <div v-if="open" class="confirm-dialog">
      <div class="confirm-dialog__backdrop" @click="$emit('cancel')"></div>

      <div class="confirm-dialog__panel" role="dialog" aria-modal="true" :aria-label="title">
        <header class="confirm-dialog__head">
          <div>
            <p class="confirm-dialog__eyebrow">{{ eyebrowLabel }}</p>
            <h2 class="confirm-dialog__title">{{ title }}</h2>
          </div>

          <button class="confirm-dialog__close" type="button" aria-label="Cerrar" @click="$emit('cancel')">
            <i class="fa fa-times"></i>
          </button>
        </header>

        <section class="confirm-dialog__body">
          <p class="confirm-dialog__message">{{ message }}</p>
        </section>

        <footer class="confirm-dialog__foot">
          <button class="confirm-dialog__ghost" type="button" :disabled="loading" @click="$emit('cancel')">
            {{ cancelLabel }}
          </button>

          <button
            v-if="showConfirm"
            class="confirm-dialog__danger"
            type="button"
            :disabled="loading"
            @click="$emit('confirm')"
          >
            {{ loading ? 'Procesando...' : confirmLabel }}
          </button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Confirmar acción'
    },
    message: {
      type: String,
      default: 'Esta acción no se puede deshacer.'
    },
    loading: {
      type: Boolean,
      default: false
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    confirmLabel: {
      type: String,
      default: 'Confirmar'
    },
    cancelLabel: {
      type: String,
      default: 'Cancelar'
    }
  },
  computed: {
    eyebrowLabel () {
      return this.showConfirm ? 'Confirmacion' : 'Informacion'
    }
  }
}
</script>

<style scoped>
.confirm-dialog {
  position: fixed;
  inset: 0;
  z-index: 750;
  display: grid;
  place-items: center;
  padding: 1rem;
}

.confirm-dialog__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(21, 17, 13, 0.46);
  backdrop-filter: blur(6px);
}

.confirm-dialog__panel {
  position: relative;
  width: min(520px, calc(100vw - 2rem));
  border: 1px solid rgba(255, 255, 255, 0.56);
  border-radius: 28px;
  background: linear-gradient(180deg, rgba(255, 252, 247, 0.99), rgba(246, 239, 231, 0.97));
  box-shadow: 0 30px 70px rgba(28, 22, 16, 0.18);
  overflow: hidden;
}

.confirm-dialog__head,
.confirm-dialog__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1rem 0.9rem;
}

.confirm-dialog__body {
  padding: 0 1rem 1rem;
}

.confirm-dialog__eyebrow {
  margin: 0 0 0.3rem;
  font-size: 0.72rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(58, 46, 33, 0.48);
}

.confirm-dialog__title {
  margin: 0;
  color: #211913;
  font-size: 1.2rem;
}

.confirm-dialog__message {
  margin: 0;
  color: #4a3a2d;
  line-height: 1.45;
}

.confirm-dialog__close {
  width: 2.2rem;
  height: 2.2rem;
  border: 1px solid rgba(102, 81, 57, 0.12);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.72);
  color: #392d22;
  flex-shrink: 0;
}

.confirm-dialog__foot {
  justify-content: flex-end;
  padding-top: 0;
  padding-bottom: 1rem;
}

.confirm-dialog__ghost,
.confirm-dialog__danger {
  min-height: 2.5rem;
  padding: 0 0.9rem;
  border-radius: 999px;
}

.confirm-dialog__ghost {
  border: 1px solid rgba(102, 81, 57, 0.12);
  background: rgba(255, 255, 255, 0.7);
  color: #392d22;
}

.confirm-dialog__danger {
  border: 0;
  background: #b95c5c;
  color: #fff8f8;
}

.confirm-dialog-fade-enter-active,
.confirm-dialog-fade-leave-active {
  transition: opacity 0.18s ease;
}

.confirm-dialog-fade-enter-from,
.confirm-dialog-fade-leave-to {
  opacity: 0;
}
</style>
